import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageStaff() {
            return Auth.hasPermissionTo('franchise_manage_staff');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/staff/staff-permission.js